import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface DialogState {
  open: boolean;
  schema: string;
  params?: Record<string, unknown>;
  fieldErrors?: Record<string, string>;
  isLoading?: boolean;
  isSaving?: boolean;
  isDisabled?: boolean;
}

const initialState: DialogState = {
  open: false,
  schema: "",
  params: {},
  fieldErrors: {},
  isLoading: false,
  isSaving: false,
  isDisabled: false,
};

export const dialogSlice = createSlice({
  name: "dialog",
  initialState,
  reducers: {
    close: (state) => {
      state.open = false;
    },
    open: <T extends Record<string, unknown>>(
      state: DialogState,
      action: PayloadAction<{ schema: string; params?: T }>,
    ) => {
      state.open = true;
      state.schema = action.payload.schema;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      state.params = action.payload.params || {};
    },
    updateParams: <T extends Record<string, unknown>>(
      state: DialogState,
      action: PayloadAction<T>,
    ) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      state.params = {
        ...state.params,
        ...action.payload,
      };
    },
    updateFieldErrors: (
      state,
      action: PayloadAction<Record<string, string>>,
    ) => {
      state.fieldErrors = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setSaving: (state, action: PayloadAction<boolean>) => {
      state.isSaving = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  close,
  open,
  updateParams,
  updateFieldErrors,
  setLoading,
  setSaving,
} = dialogSlice.actions;

export default dialogSlice.reducer;
